<template>
  <div class="d-flex align-items-center p-0">
    <div class="user-dropdown">
      <div class="user-button">
        <div class="background-icon">
          <font-awesome-icon
            style="font-size: 1.9rem"
            class="icon"
            color="#fff"
            icon="user-circle"
            swap-opacity
          />
        </div>
        <span class="d-none d-sm-block ml-1">{{ user.usuario.nome }}</span>
        <!-- <i class="fa fa-angle-down"></i> -->
      </div>
      <div class="user-dropdown-content">
        <!-- <i class="fa fa-cogs"></i> -->
        <router-link to="/admin">Administração</router-link>
        <a href @click.prevent="logout" class="d-block d-lg-none">Sair</a>
        <!-- <i class="fa fa-sign-out"></i>  -->
      </div>
    </div>
    <font-awesome-icon
      style="font-size: 1.4rem; cursor: pointer"
      @click.prevent="logout"
      class="icon ml-3 mr-3 d-none d-lg-block"
      color="#fff"
      icon="sign-out-alt"
      swap-opacity
    />
    <!-- <a href @click.prevent="logout">Sair</a> -->
    <!-- <div
      @click.prevent="logout"
      class="ml-2 d-flex align-items-center pr-3"
      style="cursor: pointer"
    >
      <font-awesome-icon
        color="#fff"
        style="font-size: 1.4rem"
        icon="sign-out-alt"
        swap-opacity
      />
    </div> -->
  </div>
</template>

<script>
import { userKey } from "@/global";
import { mapState } from "vuex";
export default {
  name: "UserDropdown",
  computed: mapState(["user"]),
  methods: {
    logout() {
      sessionStorage.removeItem("loginPassword");
      sessionStorage.removeItem(userKey);
      this.$store.commit("setUser", null);
      this.$router.push({ name: "login" });
    },
  },
};
</script>

<style>
.user-dropdown {
  position: relative;
  height: 100%;
}

.user-button {
  display: flex;
  align-items: center;
  color: #fff;
  font-weight: 400;
  height: 100%;
  padding: 0px 10px;
  font-size: 0.8rem;
}

.background-icon {
  display: flex;
  align-items: center;
  padding: 0px;
  margin: 0px;
  border-radius: 50%;
  background-color: #aaaaab;
}

/* .icon {
  font-size: 16px;
  margin: 0px;
} */

.user-dropdown:hover {
  background-color: rgba(0, 0, 0, 0.2);
}

.user-dropdown-content {
  position: absolute;
  right: 0px;
  background-color: #232526;
  color: #fff;
  min-width: 170px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  padding: 10px;
  z-index: 2;

  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s linear;
}

.user-dropdown:hover .user-dropdown-content {
  visibility: visible;
  opacity: 1;
}

.user-dropdown-content a {
  text-decoration: none;
  /* color: #000; */
  color: #fff;
  padding: 10px;
}

.user-dropdown-content a:hover {
  text-decoration: none;
  /* border-left: solid 2px yellow; */
  background-color: rgba(255, 255, 255, 0.2);
  /* background-color: rgba(255, 255, 0, 0.2); */
  /* color: #000; */
  color: #fff;
  padding: 10px;
}
</style>